if (typeof JW === 'undefined') JW = {};
JW.ExtCommon = function ($, publ, _pri)
{
    _pri.opts.dbg_lvl = $('body').data('dbj') ? 1 : 0;
    _pri.opts.env_dev = $('body').data('dev') ? true : false;
    _pri.opts.env_int = $('body').data('int') ? true : false;

    _pri.dcg = 'color: #009800;font-weight:bold';
    _pri.dcr = 'color: #c80000;font-weight:bold';
    _pri.dcb = 'color: #0070a8;font-weight:bold';
    _pri.dcy = 'color: #a88000;font-weight:bold';

    if (_pri.opts.dbg_lvl > 0)
    {
        var cons  = window.console;
        _pri.dbg  = cons.log.bind(cons, '%c%s',     'color: #888888;', '[' + _pri.cname + ']');
        _pri.dbgG = cons.log.bind(cons, '%c%s%c%s', 'color: #888888;', '[' + _pri.cname + '] ', _pri.dcg);
        _pri.dbgR = cons.log.bind(cons, '%c%s%c%s', 'color: #888888;', '[' + _pri.cname + '] ', _pri.dcr);
        _pri.dbgB = cons.log.bind(cons, '%c%s%c%s', 'color: #888888;', '[' + _pri.cname + '] ', _pri.dcb);
        _pri.dbgY = cons.log.bind(cons, '%c%s%c%s', 'color: #888888;', '[' + _pri.cname + '] ', _pri.dcy);
    }
    else
    {
        _pri.dbg = _pri.dbgG = _pri.dbgR = _pri.dbgB = _pri.dbgY = function() {};
    }


    // _pri.dbg = function()
    // {
    //     if (_pri.opts.dbg_lvl > 0)
    //     {
    //         Array.prototype.unshift.call(arguments, '[' + _pri.cname + ']');
    //         console.log.apply(console, arguments);
    //     }
    // };
    //
    // _pri.dbgG = function()
    // {
    //     if (_pri.opts.dbg_lvl > 0)
    //     {
    //         Array.prototype.unshift.call(arguments, _pri.dcg);
    //         Array.prototype.unshift.call(arguments, '[' + _pri.cname + '] ');
    //         Array.prototype.unshift.call(arguments, 'color: #808080;');
    //         Array.prototype.unshift.call(arguments, '%c%s%c%s');
    //         console.log.apply(console, arguments);
    //     }
    // };

    _pri.isObj = function(obj)
    {
        return (typeof obj === 'object' && obj != null);
    };

    _pri.objSize = function(obj)
    {
        if (_pri.isObj(obj))
        {
            return Object.keys(obj).length;
        }

        return 0;
    };

    // escape for jQuery / CSS selectors
    _pri.escSel = function(str)
    {
        // !"#$%&'()*+,./:;<=>?@[\]^`{|}~
        return str.replace( /([!"#$%&')(*+,.\/:;<=>?@\[\]^`{|}~])/g, "\\$1" );
    };

    _pri.getCookieVal = function(k)
    {
        // ! unesaped use of v!
        var v = document.cookie.match('(^|[^;]+)\\s*' + k + '\\s*=\\s*([^;]+)');
        return v ? v.pop() : '';
    };

    _pri.roundLL = function(ll, precision)
    {
        var mult = Math.pow(10, precision);
        ll.lat = Math.round(ll.lat * mult) / mult;
        ll.lng = Math.round(ll.lng * mult) / mult;
        return ll;
    };

    _pri.numberFormat = function(no, prec, dec, sep)
    {
        no = (no + '').replace(/[^0-9+\-Ee.]/g, '');
        no = !isFinite(+no) ? 0 : +no;
        prec = !isFinite(+prec) ? 0 : Math.abs(prec);
        dec = (typeof dec === 'undefined') ? '.' : dec;
        sep = (typeof sep === 'undefined') ? ',' : sep;
        var s = '';
        var toFixedFix = function (no, prec)
        {
            var k = Math.pow(10, prec)
            return '' + (Math.round(no * k) / k)
            .toFixed(prec)
        }
        // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(no, prec) : '' + Math.round(no)).split('.');
        if (s[0].length > 3)
        {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec)
        {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }

        return s.join(dec)
    };

    _pri.mt_rand = function(min, max)
    {
        var argc = arguments.length;
        if (argc === 0)
        {
            min = 0;
            max = 2147483647;
        }
        else if (argc === 1)
        {
            _pri.dbg('!!! mt_rand() wrong arg count!');
            return 0;
        }
        else
        {
            min = parseInt(min, 10);
            max = parseInt(max, 10);
        }

        return Math.floor(Math.random() * (max - min + 1)) + min;
    };

    _pri.setDataAttr = function($elm, k, v)
    {
        $elm.data(k.toString(), v);
        $elm.attr('data-' + k.toString(), v.toString());
    };

    /**
     * Get time in ms
     * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
     * @type {function}
     * @return {number}
     */
    _pri.getTime = Date.now ||
    function() {
        return new Date().getTime();
    };

    /**
     * Returns a function, that, when invoked, will only be triggered at most once
     * during a given window of time. Normally, the throttled function will run
     * as much as it can, without ever going more than once per `wait` duration;
     * but if you'd like to disable the execution on the leading edge, pass
     * `{leading: false}`. To disable execution on the trailing edge, ditto.
     * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
     * @param {function} func
     * @param {number} wait
     * @param {Object=} options
     * @returns {Function}
     */
    _pri.throttle = function(func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        options || (options = {});
        var later = function() {
            previous = options.leading === false ? 0 : _pri.getTime();
            timeout = null;
            result = func.apply(context, args);
            context = args = null;
        };
        return function() {
            var now = _pri.getTime();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0) {
                clearTimeout(timeout);
                timeout = null;
                previous = now;
                result = func.apply(context, args);
                context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    };

    _pri.encodeHTML = function(str)
    {
        // // not complete ... but should be sufficient here ...
        // return str.replace(/[\u00A0-\u9999<>\&]/gim, function(i) {
        //     return '&#' + i.charCodeAt(0) + ';';
        // });
        var map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };

        return str.replace(/[&<>"']/g, function(m) { return map[m]; });
    };

    _pri.rawurlencode = function(str)
    {
        str = (str + '')

        // Tilde should be allowed unescaped in future versions of PHP (as reflected below),
        // but if you want to reflect current
        // PHP behavior, you would need to add ".replace(/~/g, '%7E');" to the following.
        return encodeURIComponent(str)
            .replace(/!/g, '%21')
            .replace(/'/g, '%27')
            .replace(/\(/g, '%28')
            .replace(/\)/g, '%29')
            .replace(/\*/g, '%2A')
            .replace(/~/g, '%7E');
    };

    _pri.rawurldecode = function(str)
    {
        return decodeURIComponent((str + '')
            .replace(/%(?![\da-f]{2})/gi, function() {
                // PHP tolerates poorly formed escape sequences
                return '%25';
        }));
    };

    //################################################################################################################################
    //################################################################################################################################
    //################################################################################################################################

    _pri.tpls = {};

    _pri.initTpls = function(sel)
    {
        _pri.dbgG('*** initTpls() sel:', sel);
        var $tpls_wrp = $(sel);
        var $tpls = $tpls_wrp.children();
        $tpls.each(function(k) {
            var $this = $(this);
            // _pri.dbg('    tpl id: ' + $this.attr('id'));
            _pri.tpls[$this.attr('id')] = this.outerHTML;
        });

        _pri.dbg('    tpls:', _pri.tpls);
        $tpls_wrp.remove();
    };

    publ.getTpl = function(tpl_id)
    {
        _pri.dbgY('*** getTpl() known keys:', Object.keys(_pri.tpls));

        if (typeof _pri.tpls[tpl_id] === 'string')
        {
            return _pri.tpls[tpl_id];
        }
        _pri.dbg('!!! missing tpl [' + tpl_id + ']!');
    };

    publ.hasTpl = function(tpl_id)
    {
        return (typeof _pri.tpls[tpl_id] === 'string');
    };
};